import { shiyong_url } from "@/components/const";

export const Sdwan = () => {
  return (
    <div className="flex justify-center  relative bg-gradient-to-br from-[#ECF5FF] via-[#9DA8FF] to-[#90C9FF] ">
      <div className="pt-[150px] w-[1920px] px-[200px] flex pb-[128px] relative ">
        <div className="flex-1  pt-[55px]">
          <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-bold text-[44px] text-[#0182FF]">
            企业出海网络解决方案
          </div>
          <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-bold  text-[55px] text-[#333333] mt-[21px]">
            全球SD-WAN网络加速服务
          </div>
          <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-Regular text-[26px] text-[#333333] mt-[7px]">
            跨境电商 海外直播 外贸办公加速 企业全球组网
          </div>
          <div className="w-[187px] h-[66px] bg-gradient-to-br from-[#5F97FF] to-[#0182FF] rounded-[11px] mt-[31px] flex items-center justify-center">
            <a href={shiyong_url} target="_blank">
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[28px] text-[#FFFFFF]">
                立即咨询
              </div>
            </a>
          </div>
        </div>
        <img src="/imgs/sdwan/1.png" className="h-[436px] w-[460px] " />
      </div>
      <div className="flex gap-[20px] w-[1920px]  absolute  left-1/2 -translate-x-1/2 px-[200px] bottom-[-100px]">
        <img className="h-[200px] w-full  " src="/imgs/sdwan/2.png" />
        <img className="h-[200px] w-full  " src="/imgs/sdwan/3.png" />
        <img className="h-[200px] w-full  " src="/imgs/sdwan/4.png" />
      </div>
    </div>
  );
};
